/**
 * @private
 */
export const platformName = {
  nativeScript: 'NativeScript',
  html5: 'HTML5',
  nodeJs: 'nodejs',
  phoneGap: 'PhoneGap'
};



// WEBPACK FOOTER //
// /home/travis/build/Kinvey/js-sdk/src/core/platform-configs/platform-name.js